export default "__VITE_ASSET__cbb90549__"